<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-select></create-select>
    </div>
  </div>
</template>

<script>
import CreateSelect from "../../components/CreateSelect.vue";

export default {
  components: {
    CreateSelect
  },
  name: "Select",
  data() {
    return {
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {}
};
</script>
<style>
</style>
